export type SelectedImage = {
    patientId: string;
    studyInstanceUID: string;
    seriesInstanceUID: string;
};

export const STEPS = ['searchPatients', 'selectImages', 'finish'] as const;
